import {
  verifyTokenStarted,
  verifyUserSuccess,
  verifyTokenEnd,
  userLoginStarted,
  userLoginFailure,
  userLogout,
  removeChild,
  updateChildrenUser,
  updateSchool,
  changeSuperAdminView,
} from '../actions/authActions';
import { REFRESHTOKENAPI } from '../../services/Auth/RefreshToken.api';
import { LOGINAPI } from '../../services/Auth/Login.api';
import { LOGOUTAPI } from '../../services/Auth/Logout.api';

// handle verify token
export const verifyTokenAsync =
  (silentAuth = false) =>
    async (dispatch) => {
      dispatch(verifyTokenStarted(silentAuth));

      const result = await REFRESHTOKENAPI();
      if (result && result.error) {
        dispatch(verifyTokenEnd());
        if (
          result &&
          result.response &&
          [401, 403].includes(result.response.status)
        )
          dispatch(userLogout());
        return;
      }
      if (result && result.status === 204) {
        dispatch(verifyTokenEnd());
        return;
      } else if (result && result.status === 200) {
        dispatch(verifyUserSuccess(result && result.data));
        return;
      } else {
        dispatch(userLogout());
        return;
      }
    };

// handle user login
export const userLoginAsync = (data) => async (dispatch) => {
  dispatch(userLoginStarted());

  const result = 'await LOGINAPI(data)';
  if (result && result.error) {
    const { response: { data: { error } = {} } = {} } = result;
    dispatch(userLoginFailure(error && error.message));
    return;
  } else if (result !== undefined)
    dispatch(verifyUserSuccess(result && result.data));
};

// handle user logout
export const userLogoutAsync = () => async (dispatch) => {
  const result = await LOGOUTAPI();
  if (result && result.status === 200) {
    dispatch(userLogout());
  }
};

//update parent child
export const removeChildAsync = (data) => async (dispatch) => {
  dispatch(removeChild(data));
};

export const updateChildrenUserAsync = (data) => async (dispatch) => {
  dispatch(updateChildrenUser(data));
};

//update parent child
export const updateSchoolAsync = (data) => async (dispatch) => {
  dispatch(updateSchool(data));
};

export const changeSuperAdminViewAsync = (data) => async (dispatch) => {
  dispatch(changeSuperAdminView(data));
};
